"use client";
import Services from "@/components/Services";

export default function ServicesPage() {
  return <Services />;
}
